<template>
  <div class="share-code-post-page">
    <div
      v-if="!postImgUrl"
      id="share-code-post-content"
      class="share-code-post-content"
    >
      <img
        class="share-code-post-bg"
        src="@/assets/img/chargingVoucher/bg-share-code-post.png"
      >
      <img
        v-if="qrCodeImgUrl"
        class="share-code-post-qrcode"
        :src="qrCodeImgUrl"
      >
      <span class="share-code-post-text">
        分享码：{{ this.encryptedPhone }}
      </span>
    </div>

    <div
      v-else
      class="share-code-post-img-box"
    >
      <img
        class="share-code-post-img"
        :src="postImgUrl"
      >
    </div>

    <div class="h-120" />
    <div class="share-code-post-page-btns h-120">
      <div class="share-code-post-page-btn btn-primary">长按二维码转发图片</div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { generateQRCode } from '@/common/api.js';
import tokenMixin from './mixins/tokenMixin.js';

export default {
  name: 'ShareCodePost',
  data() {
    return {
      postImgUrl: '',
      qrCodeImgUrl: '',
      phone: ''
    };
  },
  mixins: [tokenMixin],
  mounted() {
    this.scrollToTop();
  },
  computed: {
    encryptedPhone() {
      if (!this.phone) return '';
      const startStr = this.phone.substr(0, 3);
      const endStr = this.phone.substr(7, 4);
      return `${startStr}****${endStr}`;
    }
  },
  methods: {
    init() {
      const query = this.$route.query;
      // 处理从小程序入口跳转过来
      if (Object.keys(query).length) {
        // 基础信息
        const phone = this.$route.query.phone || '';
        if (phone) localStorage.setItem('_phone', phone);

        // this.$router.replace({
        //   name: 'ChargingVoucherShareCodePost'
        // });
      }

      this.$nextTick(() => {
        this.phone = localStorage.getItem('_phone') || '';
        this.toGenerateQRCode();
      });
    },
    generateImage() {
      const node = document.getElementById('share-code-post-content');
      console.log(node);
      html2canvas(node)
        .then((canvas) => {
          this.postImgUrl = canvas.toDataURL('image/png');
        })
        .catch((error) => {
          console.error('生成海报失败', error);
        });
    },
    toGenerateQRCode() {
      const param = {};
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      generateQRCode(param).then((res) => {
        const head = 'data:image/png;base64,';
        this.qrCodeImgUrl = `${head}${res}`;
        this.$nextTick(() => {
          this.generateImage();
        });
        this.$toast.clear();
      });
    },
    scrollToTop() {
      const sTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (sTop > 0) {
        window.requestAnimationFrame(this.scrollToTop);
        window.scrollTo(0, sTop - sTop / 8);
      }
    },
    toShareImage() {
      const _that = this;
      const url = '/pages/extend/middle';
      wx.miniProgram.navigateTo({
        url: `${url}?type=sharePost&url=${encodeURIComponent(
          _that.postImgUrl
        )}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.share-code-post-page {
  box-sizing: border-box;

  .share-code-post-content {
    width: 750px;
    height: 1500px;
    position: relative;
    display: flex;
    justify-content: center;

    .share-code-post-bg {
      width: 750px;
      height: 1500px;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      object-fit: contain;
    }
    .share-code-post-qrcode {
      width: 280px;
      height: 280px;
      position: absolute;
      top: 465px;
      transform: translateX(5px);
      z-index: 2;
      object-fit: contain;
    }
    .share-code-post-text {
      font-size: 24px;
      color: #646464;
      letter-spacing: -1.11px;
      font-weight: 400;
      line-height: 33px;
      display: inline-block;
      position: absolute;
      top: 752px;
      transform: translateX(5px);
      z-index: 2;
      white-space: nowrap;
    }
  }
  .share-code-post-img-box {
    width: 750px;
    height: 1500px;

    .share-code-post-img {
      width: 750px;
      height: 1500px;
      object-fit: contain;
    }
  }
  .share-code-post-page-btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px rgba(230, 230, 230, 1);
    position: fixed;
    z-index: 99;
    bottom: 0;
    left: 0;
    padding: 15px 32px;
    padding-bottom: calc(15px + constant(safe-area-inset-bottom));
    padding-bottom: calc(15px + env(safe-area-inset-bottom));
    height: calc(120px + constant(safe-area-inset-bottom));
    height: calc(120px + env(safe-area-inset-bottom));
    width: 100vw;

    .share-code-post-page-btn {
      height: 90px;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;

      &.btn-default {
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 32px;
        color: #383838;
        font-weight: 400;
      }
      &.btn-primary {
        background: #fe6456;
        font-size: 32px;
        color: #ffffff;
        font-weight: 400;
      }
    }
  }
}
.h-120 {
  height: calc(120px + constant(safe-area-inset-bottom));
  height: calc(120px + env(safe-area-inset-bottom));
}
</style>
